import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import NumberFormat from 'react-number-format';

import { toggleConvertUserModal } from '../actions/clients-actions';
import RenderIf from '../../../shared/render-if/components/render-if';
import clientsConstants from '../constants/clients-constants';
import constants from '../../../../common/constants';
import Helpers from '../../../../common/helpers';
import ClientsHelpers from '../helpers/clients-helpers';
import registerConstants from '../../register/constants/register-constants';

import '../styles/clients-table.css';

class ClientsTable extends Component {
  renderTableHead(items) {
    const { t } = this.context;
    const { profile } = this.props;

    let hiddenLabels = [];
    if (profile && (profile.user_type === registerConstants.user_types.ib || profile.user_type === registerConstants.user_types.ifs_type)) {
      hiddenLabels = clientsConstants.ib_ifs_user_hidden_labels;
    }

    if (items && items.length > 0) {
      return items.map((item, index) => {
        const isHiddenLabel = hiddenLabels.indexOf(item.label) > -1;

        return !isHiddenLabel && <th key={index}>{t(item.label)}</th>;
      });
    } else return null;
  }

  renderTableBody(items, isOnlineAffiliate) {
    const { t } = this.context;
    const { profile } = this.props;
    const browser = Helpers.detectBrowser();

    if (items && items.length) {
      return items.map((item, index) => {
        return (
          <tr key={index} className="payment-history-table-container__table__body__row">
            <td>{item.user_id}</td>
            <RenderIf if={isOnlineAffiliate}>
              <td>{ClientsHelpers.hideField(item.email, true, 2)}</td>
            </RenderIf>
            <RenderIf if={!isOnlineAffiliate}>
              <td>{item.email}</td>
            </RenderIf>
            <td>{item.status}</td>
            <td>{this.formatUserLevels(item.user_level)}</td>
            <td>
              <NumberFormat thousandSeparator={true} prefix={'$'} value={parseFloat(item.deposited_sum || 0).toFixed(2)} displayType={'text'} />
            </td>
            <td>
              <NumberFormat thousandSeparator={true} prefix={'$'} value={parseFloat(item.withdrawn_sum || 0).toFixed(2)} displayType={'text'} />
            </td>
            <td>
              <NumberFormat thousandSeparator={true} prefix={'$'} value={parseFloat(item.net_deposit_sum || 0).toFixed(2)} displayType={'text'} />
            </td>
            <td>{item.trades_made || 0}</td>
            <td>{item.valid_trades_made || 0}</td>
            <td>
              <NumberFormat thousandSeparator={true} value={item.lots || 0} decimalScale={2} displayType={'text'} />
            </td>
            <td>
              <NumberFormat thousandSeparator={true} value={item.valid_lots || 0} decimalScale={2} displayType={'text'} />
            </td>
            {profile.user_type !== registerConstants.user_types.ib &&
              profile.user_type !== registerConstants.user_types.ifs_type && [
                <td key={1}>
                  <NumberFormat thousandSeparator={true} prefix={'$'} value={parseFloat(item.commission_earned_achievement || 0).toFixed(2)} displayType={'text'} />
                </td>,
                <td key={2}>
                  <NumberFormat thousandSeparator={true} prefix={'$'} value={parseFloat(item.commission_earned_trading || 0).toFixed(2)} displayType={'text'} />
                </td>,
              ]}
            <td>
              <NumberFormat thousandSeparator={true} prefix={'$'} value={parseFloat(item.commission_sum || 0).toFixed(2)} displayType={'text'} />
            </td>
            {profile.user_type !== registerConstants.user_types.ib &&
              profile.user_type !== registerConstants.user_types.ifs_type && (
                <td>
                  <NumberFormat thousandSeparator={true} prefix={'$'} value={parseFloat(item.commission_pending || 0).toFixed(2)} displayType={'text'} />
                </td>
              )}
            <td onClick={() => this.openConvertUserModal(item)} className={`${browser !== constants.browsers.safari ? 'display-inline' : ''}`}>
              <div className={`transparent-btn ${item.status !== constants.account_types.demo.text ? 'transparent-btn-disabled' : ''}`}>{t('CLIENTS.CONVERT_BTN')}</div>
            </td>
          </tr>
        );
      });
    } else return null;
  }

  formatUserLevels(level) {
    return ClientsHelpers.formatUserLevels(level);
  }

  openConvertUserModal(user) {
    if (user.status !== constants.account_types.demo.text) {
      return;
    }

    const { toggleConvertUserModal } = this.props;

    toggleConvertUserModal(true);
  }

  filterTableColumns(isOnlineAffiliate, columns) {
    const { profile } = this.props;

    let hiddenLabels = [];
    if (profile && (profile.user_type === registerConstants.user_types.ib || profile.user_type === registerConstants.user_types.ifs_type)) {
      hiddenLabels = clientsConstants.ib_ifs_user_hidden_labels;
    }

    if (isOnlineAffiliate) {
      _.remove(columns, column => {
        return (
          column.value === clientsConstants.hidden_columns.first_name ||
          column.value === clientsConstants.hidden_columns.last_name ||
          column.value === clientsConstants.hidden_columns.phone_number ||
          hiddenLabels.indexOf(column.value) > -1
        );
      });
    }

    return columns;
  }

  render() {
    const { clients, isOnlineAffiliate } = this.props;
    const columns = this.filterTableColumns(isOnlineAffiliate, clientsConstants.clients_table_columns);

    return (
      <div className="clients-table-container m-t-30 table-responsive clients-table">
        <table className="payment-history-table-container__table">
          <thead className="payment-history-table-container__table__head">
            <tr className="payment-history-table-container__table__head__row">{this.renderTableHead(columns)}</tr>
          </thead>
          <tbody className="payment-history-table-container__table__body">{this.renderTableBody(clients, isOnlineAffiliate)}</tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  clients: state.clientsReducer.clients,
});

const mapDispatchToProps = dispatch => ({
  toggleConvertUserModal: show => {
    dispatch(toggleConvertUserModal(show));
  },
});

ClientsTable.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientsTable);



// WEBPACK FOOTER //
// ./src/app/main/clients/components/clients-table.js